import React, { PureComponent } from 'react'
import { ChildContainer, Overlay } from './_styled/menu-controller.styled'
import Header from '../header'
import Footer from './footer'
//import BannerPromotionSection from '../sections/banner-promotion'

class MenuController extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      menuOpen: false,
      popupOpen: false,
    }

    this.setPopup = this.setPopup.bind(this)
  }

  componentDidMount() {
    const { menuOpen } = this.state
    this.setState({ popupOpen: false })

    document.body.style.overflow = menuOpen ? 'hidden' : 'auto'

    window.addEventListener('resize', () => this.setState({ popupOpen: false }))

    document.body.addEventListener('click', event => {
      const closest = (element, fn) =>
        element && (fn(element) ? element : closest(element.parentNode, fn))

      const popupIdentifier = 'gh-ppvr-cnt-gh-profile-dd'

      const closestElement = closest(event.target, element => element.id === popupIdentifier)

      if (!closestElement) {
        this.setState({ popupOpen: false })
      }
    })
  }

  setMenuOpen = menuOpen => {
    this.setState({
      menuOpen,
    })

    document.body.style.overflow = menuOpen ? 'hidden' : 'auto'
  }

  setPopup() {
    this.setState(prevState => ({
      popupOpen: !prevState.popupOpen,
    }))
  }

  render() {
    const { children, services, pages, about, socials, support, footerContent, languages, originalPath, t, i18n } = this.props
    const { menuOpen, popupOpen } = this.state
    
    return (
      <>
        <Header
          menuOpen={menuOpen}
          setMenuOpen={this.setMenuOpen}
          popupOpen={popupOpen}
          setPopup={this.setPopup}
          t={t}
          languages={languages}
          i18n={i18n}
          originalPath={originalPath}
        />
        {menuOpen && <Overlay onClick={() => this.setMenuOpen(false)} />}          
        <ChildContainer>{children}</ChildContainer>
        <Footer
          about={about}
          services={services}
          pages={pages}
          socials={socials}
          support={support}
          content={footerContent}
          t={t}
        />
      </>
    )
  }
}


export default MenuController
